import { AssessmentEvent } from "../scripts/assessments.entities";


export class AssessmentsDatatableEntry {
    Study: string;
    Appendix: string;
    Site: string;
    SiteNumber: string;
    Visit: string;
    Assessment: string;

    PotentialVisits: number;
    ExpectedVisits: number;
    Completed: number[] = [];
    Overdue: number[] = [];
    NotDone: number[] = [];
    DiscPrior: number[] = [];
    NotYetDue: number;

    CompletedVisits: AssessmentEvent[] = [];
    OverdueVisits: AssessmentEvent[] = [];
    NotDoneVisits: AssessmentEvent[] = [];
    DiscPriorVisits: AssessmentEvent[] = [];

    sortValue: number;

    constructor(study: string, appendix: string, site: string, siteNumber: string, visit: string, assessment: string) {
        this.Study = study;
        this.Appendix = appendix;
        this.Site = site;
        this.SiteNumber = siteNumber;
        this.Visit = visit;
        this.Assessment = assessment;

        this.PotentialVisits = 0;
        this.ExpectedVisits = 0;
        this.NotYetDue = 0;
    }

    addVisitEvent(visit: AssessmentEvent): void {
        this.PotentialVisits += 1;

        switch (visit.StatusId) {
            case 1: 
                this.Completed[0] = (this.Completed[0] ?? 0) + 1;
                this.ExpectedVisits++;
                this.CompletedVisits.push(visit);
                break;
            case 6:
                this.Overdue[0] = (this.Overdue[0] ?? 0) + 1;
                this.ExpectedVisits++;
                this.OverdueVisits.push(visit);
                break;
            case 3:
                this.NotDone[0] = (this.NotDone[0] ?? 0) + 1;
                this.ExpectedVisits++;
                this.NotDoneVisits.push(visit);
                break;
            case 2:
                this.DiscPrior[0] = (this.DiscPrior[0] ?? 0) + 1;
                this.ExpectedVisits++;
                this.DiscPriorVisits.push(visit);
                break;
            case 5:
                this.NotYetDue = (this.NotYetDue ?? 0) + 1;
                break;
        }

        //    switch (visit.StatusId) {
        //     case 1: this.Completed[0] = (this.Completed[0] == undefined) ? 1 : (this.Completed[0] + 1); this.ExpectedVisits += 1; this.CompletedVisits.push(visit); break;
        //     //case 2: this.NotYetDone = (this.NotYetDone == undefined) ? 1 : (this.NotYetDone + 1); break;
        //     case 6: this.Overdue[0] = (this.Overdue[0] == undefined) ? 1 : (this.Overdue[0] + 1); this.ExpectedVisits += 1; this.OverdueVisits.push(visit); break;
        //     case 3: this.NotDone[0] = (this.NotDone[0] == undefined) ? 1 : (this.NotDone[0] + 1); this.ExpectedVisits += 1; this.NotDoneVisits.push(visit); break;
        //     case 2: this.DiscPrior[0] = (this.DiscPrior[0] == undefined) ? 1 : (this.DiscPrior[0] + 1); this.ExpectedVisits += 1; this.DiscPriorVisits.push(visit); break;
        //     case 4:
        //     case 5:
        //         this.NotYetDue = (this.NotYetDue == undefined) ? 1 : (this.NotYetDue + 1); break;
        // }       
    }

    initialize(): void {
        if (this.ExpectedVisits > 0) {
            if (this.Completed[0] != undefined) { this.Completed[1] = (this.Completed[0] / this.ExpectedVisits); }
            if (this.Overdue[0] != undefined) { this.Overdue[1] = (this.Overdue[0] / this.ExpectedVisits); }
            if (this.NotDone[0] != undefined) { this.NotDone[1] = (this.NotDone[0] / this.ExpectedVisits); }
            if (this.DiscPrior[0] != undefined) { this.DiscPrior[1] = (this.DiscPrior[0] / this.ExpectedVisits); }
        }
    }

    static addValue(currentValue: number, valueToAdd: number): number {
        if (currentValue == undefined) { currentValue = 0; }
        currentValue += valueToAdd;
        return currentValue;
    }

    static getHash(grouping: string, visit: AssessmentEvent): string {
        if (grouping == "none") { return visit.StudyId + "-" + visit.AppendixId + "-" + visit.SiteNumber + "-" + visit.TimepointId + "-" + visit.AssessmentId; }
        else if (grouping == "by-visit") { return visit.StudyId + "-" + visit.AppendixId + "-" + visit.TimepointId; }
        else if (grouping == "by-site") { return visit.StudyId + "-" + visit.AppendixId + "-" + visit.SiteNumber; }
        else if (grouping == "by-assessment") { return visit.StudyId + "-" + visit.AppendixId + "-" + visit.AssessmentId; }
        else return "unknown";
    }
}
